import React from 'react'

export default ({ condition, Component, children, ...props }) => {
	if (condition) {
		return <Component {...props}>{children}</Component>
	} else {
		return children
	}
}
